export default __webpack_public_path__ + "static/media/2100-00 to 2105-00 wo text.1ec32332.jpg";